var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58171 0 0 3.58171 0 8V40C0 44.4183 3.58171 48 8 48H40C44.4183 48 48 44.4183 48 40V8C48 3.58171 44.4183 0 40 0H8ZM10.3839 10.2857H19.4554L25.8973 19.4397L33.7143 10.2857H36.5714L27.1875 21.2723L38.7589 37.7143H29.6897L22.2143 27.0938L13.1429 37.7143H10.2857L20.9241 25.2612L10.3839 10.2857ZM14.7589 12.5714L30.8817 35.4286H34.3839L18.2612 12.5714H14.7589Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.cf51afd2893714e9227fe4ca33e1e25c.svg";
export { ForwardRef as ReactComponent };